<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      服务商管理
      <small>
        /&nbsp;
        <router-link to="/distributorlist" class="TitleStyle">服务商列表</router-link>/&nbsp;服务商详情
      </small>
    </h1>
    <!-- end col-6 -->
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">服务商详情</h4>
              </div>
              <!-- end panel-heading -->
              <div class="OrderInfo">
                <div class="OrderGroup">
                  <div class="GTitle">
                     <span class="TInfo">基本信息</span>
                  </div>
                  <div class="GContent">
                    <ul class="GContentUl">
                      <li class="TableContent">
                        <span class="TCode">分组编号：</span>
                        <span class="TCodeContent">{{DistributorList.groupCode}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">分组名称：</span>
                        <span class="TCodeContent">{{DistributorList.groupName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">所属机构：</span>
                        <span class="TCodeContent">{{DistributorList.deptName ? DistributorList.lesseeName + ' - ' + DistributorList.deptName : DistributorList.lesseeName }}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">大区：</span>
                        <span class="TCodeContent">{{DistributorList.areaNames}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">服务商渠道号：</span>
                        <span class="TCodeContent">{{DistributorList.recom}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">服务商编码：</span>
                        <span class="TCodeContent">{{DistributorList.recomCode}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">服务商名称：</span>
                        <span class="TCodeContent">{{DistributorList.recomName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">服务商用户名：</span>
                        <span class="TCodeContent">
                          {{DistributorList.loginUser}}&nbsp;&nbsp;
                          <a href="javascript:void(0);" @click="changePwd(DistributorList.recomId);">[修改密码]</a>
                        </span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">负责人姓名：</span>
                        <span class="TCodeContent">{{DistributorList.userName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">负责人手机号：</span>
                        <span class="TCodeContent">{{DistributorList.tel}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">所在省：</span>
                        <span class="TCodeContent">{{DistributorList.province}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">所在市：</span>
                        <span class="TCodeContent">{{DistributorList.city}}</span>
                      </li>
                        <li class="TableContent">
                        <span class="TCode">所在区：</span>
                        <span class="TCodeContent">{{DistributorList.district}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">详细地址：</span>
                        <span class="TCodeContent">{{DistributorList.address}}</span>
                      </li>
                      <li class="TableContent" style="width:50%;">
                        <span class="TCode">域名地址：</span>
                        <span class="TCodeContent">{{DistributorList.domainUrl}}</span>
                      </li>
                      <li class="clear"></li>
                    </ul>
                  </div>
                  <div class="GTitle">
                    <span class="TInfo">支付账户信息</span>
                  </div>
                  <div class="GContent">
                    <ul class="GContentUl">
                      <li class="TableContent">
                        <span class="TCode">账户类型：</span>
                        <span class="TCodeContent">
                          {{
                            {
                              'P': '个人户',
                              'C': '公司户'
                            }[payAccountInfos.bankType]
                          }}
                        </span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">账户名称：</span>
                        <span class="TCodeContent">{{payAccountInfos.trueName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">银行卡号：</span>
                        <span class="TCodeContent">{{payAccountInfos.bankCard}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">开户银行：</span>
                        <span class="TCodeContent">{{DistributorList.bankName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">银行所属省份：</span>
                        <span class="TCodeContent">{{payAccountInfos.bankProvince}}</span>
                      </li>
                       <li class="TableContent">
                        <span class="TCode">银行所属城市：</span>
                        <span
                          class="TCodeContent"
                        >{{payAccountInfos.bankCity}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">开户支行：</span>
                        <span
                          class="TCodeContent"
                        >{{payAccountInfos.bankBranchName}}</span>
                      </li>
                      <li class="TableContent" v-if="payAccountInfos.bankType === 'P'">
                        <span class="TCode">持卡人身份证号：</span>
                        <span class="TCodeContent">{{payAccountInfos.idCard}}</span>
                      </li>
                      <li class="TableContent" v-if="payAccountInfos.bankType === 'C'">
                        <span class="TCode">统一社会信用代码：</span>
                        <span class="TCodeContent">{{payAccountInfos.creditCode}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">持卡人手机号：</span>
                        <span class="TCodeContent">{{payAccountInfos.bankTel}}</span>
                      </li>
                      <li class="clear"></li>
                    </ul>
                  </div>
                  <div class="GTitle">
                    <span class="TInfo">操作信息</span>
                  </div>
                  <div class="GContent" style="text-align:left;">
                    <div class="GContentStyle">
                      <el-checkbox-group v-model="mallTypee" disabled>
                        <div style="margin-bottom:10px;">
                          <div><el-checkbox :label="1">PC商城</el-checkbox></div>
                          <div class="settingValue">
                            <template>
                              <el-radio-group v-model="auditTypePC" disabled>
                                <el-radio label="1">人工审核放行</el-radio>
                                <el-radio label="2">自动审核放行</el-radio>
                              </el-radio-group>
                            </template>
                          </div>
                        </div>
                        <div>
                          <div><el-checkbox :label="2">O2O门店</el-checkbox></div>
                          <div class="settingValue">
                            <template>
                              <el-radio-group v-model="auditTypeO2O" disabled>
                                <el-radio label="1">人工审核放行</el-radio>
                                <el-radio label="2">自动审核放行</el-radio>
                              </el-radio-group>
                            </template>
                          </div>
                        </div>
                      </el-checkbox-group>
                    </div>
                  </div>
                  <div style="height:46px;padding-top:16px;">
                    <a class="btn btn-primary m-r-5" style="float:right;cursor:pointer;color:#fff !important" @click="Goback">返&nbsp;&nbsp;回</a>
                    <span class="clear"></span>
                  </div>
                </div>
              </div>
              <el-dialog title="密码修改" :visible.sync="dialogVisible" width="30%">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                  <el-form-item label="原密码" prop="lastPwd">
                    <el-input v-model="ruleForm.lastPwd" show-password></el-input>
                  </el-form-item>
                  <el-form-item label="新密码" prop="pwd">
                    <el-input v-model="ruleForm.pwd" show-password></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
                    <el-button @click="resetForm('ruleForm')">重置</el-button>
                  </el-form-item>
                </el-form>
              </el-dialog>
            </div>
            <!-- end panel -->
          </div>

          <!-- end col-10 -->
        </div>

        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>

  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "@/common/http";

export default {
  name: "DistributorDetail",
  data() {
    var checkPwd = (rule, value, callback) => {
      setTimeout(() => {
        let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;
        if (!reg.test(value)) {
          callback(new Error("请输入8~16位以上英文+数字组合"));
        }else{
          callback();
        }
      }, 1000);
    };
    return {
      recomId: '',
      pageNo: 1,
      pageSize: 10,
      DistributorList:[],
      payAccountInfos:[],
      groupName:'',
      loginName:'',
      mallTypee: [],
      auditTypePC: '',
      auditTypeO2O: '',
      recom_id:'',
      dialogVisible: false,
      ruleForm: {
        lastPwd: '',
        pwd: ''
      },
      rules: {
        lastPwd: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
        ],
        pwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: checkPwd, trigger: "blur" }
        ]
      }
    };
  },
  mounted: function() {
    this.initdata();
    if(localStorage.getItem('userName')){
      this.loginName = JSON.parse(localStorage.getItem('userName')).userName;
    }
  },
  methods: {
    Goback(val){
       this.$router.push({ name: "DistributorList" , params: { pageNo : this.pageNo , pagesize:this.pageSize,searchContent: this.searchContent}});
    },
    initgroup(val){
     let that = this;
     const options = {
        url: "distribution/B2cRecomInfoController/queryGroupId",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            response.data.data.forEach(element => {
              if(val === element.groupId){
                that.groupName = element.groupName;
              }
            });
          } else {
            http.handleEorrorCode(response,that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    initdata() {
      let that = this;
      if(localStorage.getItem('goodlist')){
        let goodlist =localStorage.getItem('goodlist');
        this.recomId =  JSON.parse(goodlist).recomId;
        this.pageNo = JSON.parse(goodlist).pageNo;
        this.pageSize = JSON.parse(goodlist).pageSize;
        this.searchContent =  JSON.parse(goodlist).searchContent;
      }
     const initoptions = {
        url: "distribution/B2cRecomInfoController/queryRecomDetailByPage",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          recomId: JSON.parse(localStorage.getItem('goodlist')).recomId,
          companyId: JSON.parse(localStorage.getItem('goodlist')).companyId
        })
      };
      axios(initoptions)
        .then(function(response) {
          if (response.data.code == 200) {
            that.DistributorList = response.data.data;
            that.payAccountInfos = JSON.parse(response.data.data.payAccountInfos);
            if(that.payAccountInfos.bankType==='P'){
              that.payAccountInfos.banktype = '一类户'
            }
            if(that.DistributorList.recomType === 1){
              that.DistributorList.recomtype = '分销商';
            }else if(that.DistributorList.recomType === 2){
              that.DistributorList.recomtype = '服务商'
            }else if(that.DistributorList.recomType === 5) {
              that.DistributorList.recomtype = '运营'
            }
            that.initgroup(that.DistributorList.groupId);
            if(response.data.data.openSettingsFormList.length !== 0){
              response.data.data.openSettingsFormList.forEach((val,i) => {
                that.mallTypee.push(val.mallType);
                if(response.data.data.openSettingsFormList[i].mallType && response.data.data.openSettingsFormList[i].mallType == 1){
                  that.auditTypePC = response.data.data.openSettingsFormList[i].auditType + '';
                }
                if(response.data.data.openSettingsFormList[i].mallType && response.data.data.openSettingsFormList[i].mallType == 2){
                  that.auditTypeO2O = response.data.data.openSettingsFormList[i].auditType + '';
                }
              });
            }
          } else {
            http.handleEorrorCode(response,that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    changePwd(item){
      this.dialogVisible = true;
      this.recom_id = item;
    },
    // 修改密码
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          const options = {
            url: "distribution/B2cRecomInfoController/updatePwd",
            method: "post",
            headers: { "Content-Type": "application/x-www-form-urlencoded",'X-Requested-With': 'XMLHttpRequest',"Access-Control-Allow-Origin":"*" },
            data: Qs.stringify({
              lastPwd: that.ruleForm.lastPwd,
              pwd: that.ruleForm.pwd,
              recomId: that.recom_id
            })
          };
          axios(options).then(function(response) {
            if (response.data.code == 200) {
              that.dialogVisible = false;
              that.initdata();
              that.$notify({
                title: "成功",
                message: response.data.message,
                type: "success"
              });
            } else {
              http.handleEorrorCode(response,that);
            }
          }).catch(error => {
            http.handleHttpError(error, that);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ModelPadding {
  margin-top: -30px;
}
.LineSpacing {
  margin-top: 16px;
}
.ButtonColor {
  color: #fff !important;
}

.OrderInfo {
  padding: 20px 30px;
}
.GTitle {
  border-top: 3px #84caf3 solid;
  overflow: hidden;
  line-height: 25px;
  border-right: 1px #e5e5e5 solid;
  background: #f4f4f4;
}
.TInfo {
  position: relative;
  min-width: 130px;
  float: left;
  font-size: 16px;
  padding: 5px 15px;
  background-color: #84caf3;
  color: #ffffff;
}
.GContent {
  padding: 15px;
  border: 1px #e5e5e5 solid;
  border-top: none;
}

.TitleStyle {
  color: #6a7786;
}
@media screen and (max-width:1360px){
  .TableContent {
    width: 50%;
  }
}
@media screen and (min-width:1360px) and (max-width:1680px){
  .TableContent {
    width: 50%;
  }
}
@media screen and (min-width:1680px){
  .TableContent {
    width: calc(100%/3);
  }
}
.TableContent {
  float: left;
}
.GContentUl {
  list-style: none;
  margin: 0;
  padding: 0;
}
.TCode {
  color: #999999;
  text-align: left;
  width: 145px;
  overflow: hidden;
  font-size: 14px;
  float: left;
  padding-left: 16px;
  padding-top:8px;
  padding-bottom: 8px;
}
.TCodeContent {
  font-size: 12px;
  float: left;
  width: calc(100% - 145px);
  line-height: 20px;
  text-align: left;
  word-break: normal;
  word-wrap: break-word;
  padding-top:8px;
  padding-bottom: 8px;
}
.GContent {
  padding: 15px;
  border: 1px #e5e5e5 solid;
  border-top: none;
}
.tableAll,
.tableOne,
.tableSku {
  font-size: 14px;
  margin-bottom: 0;
}
.tableAll > tbody > tr > td {
  border: none;
  width: 25%;
  padding: 5px 15px;
}
.tableAll > tbody > tr {
  text-align: left;
}
.tableOne {
  border: 1px #e5e5e5 solid;
}
.tbheader {
  background: #f4f4f4;
  text-align: left;
}
.tbone {
  border: 1px #e5e5e5 solid;
}
.trbottom > td {
  border-bottom: none;
}
.tdprice {
  vertical-align: middle;
}
.GContentStyle {
  padding: 10px 30px;
}
.settingValue {
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/DistributorManage/DistributorDetail.vue